import {Module} from 'vuex';
import oApi from '@/js/hvac/talk/appoint.js'
import {commonVuex} from "../common.js";
import { state } from '@antv/g2plot/lib/adaptor/common';
import {polygon} from "@antv/g2plot";

/**
 * 用户分享数据模块
 * @type {Module}
 */
export const userTalkAppointV3 = {
    namespaced: true,
    state: {
        SupportData:[],//支持人员列表
        TemplateDetail:{},// 体验间详情
        CustomerData:[],//选择用户列表
        TemplateRoomData:[],//样板间列表
        SelectList:[],//预约信息列表
        ReportTimeData:[],//预约时间列表
        SourceList:[],//渠道列表
        ReportTimeData2:[],//提供给核销使用的时间
        ReportUserInfoData:{},//报告信息,用户信息
        ReportTagsData:[],//报告信息， 标签组
        ReportRestData:[],//休息日列表
        ReportListData:[],//报告列表
        ReportId:'',//报告id
        writeOffList:[],//核销列表
        ReportCount:{},
        distance:'',//2点之间的距离
        AgreementData:'',//隐私协议
        CustomerObj:{},//'默认带出的潜客'
        CompanyList:[],//选择设计师获取到的公司列表
        ProjectTime:[],//显示一个月的状态
        CheckList:[],//体验间点检列表 (有数据结构)
        CheckList2:[],//体验间点检列表(没有数据结构)
        SelectColumn:'',//存放点检筛选的大区城市等数组
        CheckInfoList:[],//点检需要检查的列表
        UploadImgUrl:'',//上传图片返回的图片地址
        BIdentity:false,//判断用户是不是平台管理,默认不是
        BchargePeople:false,//判断用户是否是负责人
        LocationSkip:'222',//是否验证地图
    },
    mutations: {
        SaveSupportData (state,payload) {
            state.SupportData = [...state.SupportData,...payload]
        },
        SaveSupportData2 (state,payload) {
            console.log(payload,'PAYLOAD')
            state.SupportData = payload
        },
        SaveCustomerObj (state,payload) {
            state.CustomerObj = payload[0]
        },
        SaveCustomerData (state,payload) {
            state.CustomerData = payload
        },
        SaveTemplateRoomData (state,payload) {
            state.TemplateRoomData = payload
        },
        SavewriteOffList (state,payload) {
            state.writeOffList = payload
        },
        SaveReportTimeData (state,payload) {
            state.ReportTimeData = payload
        },
        SaveSourceList (state,payload) {
            state.SourceList = payload
        },

        SaveReportTimeData2 (state,payload) {
            state.ReportTimeData2 = payload
        },
        SaveSelectList (state,payload) {
            state.SelectList = payload
        },
        SaveReportAppointData (state,payload) {
            state.ReportAppointData = payload
        },
        SaveReportUserInfoData (state,payload) {
            state.ReportUserInfoData = payload
        },
        SaveReportTagsData (state,payload) {
            state.ReportTagsData = payload
        },
        SaveUploadImg (state,payload) {
            state.UploadImgUrl = payload
        },
        SaveReportRestData (state,payload) {
            state.ReportRestData = payload
        },
        SaveBchargePeople (state,payload) {
            state.BchargePeople = payload != 0
        },
        SaveLocationSkip (state,payload) {
            console.log(payload,'payload')
            state.LocationSkip = payload
        },
        SaveReportListData (state,payload) {
            let ReportListData = payload
            let newDate = new Date();
            const year = newDate.getFullYear();
            let month = newDate.getMonth() + 1;
            let date = newDate.getDate();
            let hour = newDate.getHours();
            let minute = newDate.getMinutes();
            let second = newDate.getSeconds()
            month = (month < 10) ? '0' + month : month
            date = (date < 10) ? '0' + date : date
            hour = (hour < 10) ? '0' + hour : hour
            minute = (minute < 10) ? '0' + minute : minute
            second = (second < 10) ? '0' + second : second
            let time = year + '-' + month + '-' + date + ' ' + hour + ':' +  minute + ':' + second

            // 循环区分状态
            ReportListData = ReportListData.map (item => {
                if (item.state < 4) {
                    item.statusNum = 1
                    item.is_pass = false
                } else {
                    item.statusNum = 2
                    item.is_pass = true
                }
                return item
            })
            function compare(property1,property2) {
                return function (a,b) {
                    if (a[property1] == b[property1]) {
                        return a[property2] - b[property2]
                    } else {
                        return a[property1] - b[property1]
                    }
                }
            }
            let list = ReportListData.sort(compare('statusNum','mark_start'))
            state.ReportListData = list
        },
        SaveCheckInfoList (state,payload) {
            state.CheckInfoList = payload
        },
        SaveReportListDatas (state,payload) {
            let ReportListData = [...state.ReportListData,...payload]
            // 循环区分状态
            let newDate = new Date();
            const year = newDate.getFullYear();
            let month = newDate.getMonth() + 1;
            let date = newDate.getDate();
            let hour = newDate.getHours();
            let minute = newDate.getMinutes();
            let second = newDate.getSeconds()
            month = (month < 10) ? '0' + month : month
            date = (date < 10) ? '0' + date : date
            hour = (hour < 10) ? '0' + hour : hour
            minute = (minute < 10) ? '0' + minute : minute
            second = (second < 10) ? '0' + second : second
            let time = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second


            // 循环区分状态
            ReportListData = ReportListData.map (item => {
                // if (time > item.sub[0].mark_end) {
                //     item.is_pass = true
                // } else {
                //     item.is_pass = false
                // }
                if (item.state < 4) {
                    item.is_pass = false
                    item.statusNum = 1
                } else {
                    item.statusNum = 2
                    item.is_pass = true
                }
                return item
            })
            function compare(property1,property2) {
                return function (a,b) {
                    if (a[property1] == b[property1]) {
                        return a[property2] - b[property2]
                    } else {
                        return a[property1] - b[property1]
                    }
                }
            }
            let list = ReportListData.sort(compare('statusNum','mark_start'))
            state.ReportListData = list
        },
        SaveCheckList (state,payload) {
            // 这里是做区分,将同一天时间的体验间点检放在一起
            // console.log(payload,'payload');
            state.CheckList2 = payload
            // console.log(state.CheckList2,'覆盖');
            let list = []
            let obj = {}
            state.CheckList2.map( (item,index) => {
                // 判断这个时间是否存在数组中,如果存在就添加到这个里去,如果不存在就新这个一个时间
                let index2 = list.findIndex(item2 => item2.time == item.created_date)
                if ( index2 == -1 ) {
                    obj = {
                        time:item.created_date,
                        children:[item]
                    }
                    list.push(obj)
                } else {
                    list[index2].children.push(item)
                }
            })
            list.map (i => {
                if(i.time) {
                    i.time = Number(i.time.split('-')[1]) + '月' + Number(i.time.split('-')[2]) + '日'
                }
                return i
            })
            state.CheckList = list
        },
        // 下拉
        SaveCheckList2 (state,payload) {
            // 这里是做区分,将同一天时间的体验间点检放在一起
            state.CheckList2 = [...state.CheckList2,...payload]
            console.log(state.CheckList2,'添加');
            let list = []
            let obj = {}
            state.CheckList2.map( (item,index) =>{
                // 判断这个时间是否存在数组中,如果存在就添加到这个里去,如果不存在就新这个一个时间
                let index2 = list.findIndex(item2 => item2.time == item.created_date)
                if ( index2 == -1 ) {
                    obj = {
                        time:item.created_date,
                        children:[item]
                    }
                    list.push(obj)
                } else {
                    list[index2].children.push(item)
                }
            })
            list.map (i => {
                if(i.time) {
                    i.time = Number(i.time.split('-')[1]) + '月' + Number(i.time.split('-')[2]) + '日'
                }
                return i
            })
            state.CheckList = list
        },
        SaveCheckList3 (state,payload) {
            state.CheckList = payload
        },
        SaveCheckList4 (state,payload) {
            state.CheckList = [...state.CheckList,...payload]
        },
        SaveSelectColumn (state,payload) {
            state.SelectColumn = payload
        },
        SaveAgreement (state,payload) {
            state.AgreementData = payload
        },
        SaveReportId (state,payload) {
            state.ReportId = payload
        },
        SaveFeedType (state,payload) {
            state.feed_type = payload
        },
        SaveTemplateDetail (state,payload) {
            state.TemplateDetail = payload
        },
        SaveFeedObj (state,payload) {
            state.feedObj = payload
        },
        SaveCompanyList (state,payload) {
            state.CompanyList = payload
        },
        SaveIdentity (state,payload) {
            state.BIdentity = payload
        },
        SaveProjectTime (state,payload) {
            state.ProjectTime = payload
        },
        SaveDistance (state,payload) {
            console.log(payload,'payload');
            payload = payload.split(',')
            let distance = 0
            for (let index = 0; index < payload.length; index++) {
                distance += payload[index] * 1000 **(payload.length-index-1)
            }
            state.distance = distance
        },
        SaveReportCount (state,payload) {
            // console.log(parseInt(payload.list[1].num),'useraccount1');
            // console.log(parseInt(payload.list[2].num),'useraccount2');//接受邀请
            // console.log((payload.list),'useraccount3');//已体验
            // let Invite = parseInt(payload.list[2].num)/(parseInt(payload.list[1].num) + parseInt(payload.list[2].num))
            // let Experience = parseInt(payload.list[3].num)/(parseInt(payload.list[3].num) + parseInt(payload.list[2].num))
            // Invite=  Math.round(Number(Invite)*100)
            // Experience=  Math.round(Number(Experience)*100)
            let Invite= parseInt(payload.list[2].num)/parseInt(payload.count)
            let Experience= parseInt(payload.list[3].num)/parseInt(payload.count)
            Invite=  Math.round(Number(Invite)*100)
            Experience=  Math.round(Number(Experience)*100)
            let zero = false
            if (payload.count == 0) {
                zero = true
            }
            state.ReportCount = {
                Invite,
                Experience,
                zero
            }
        },
        RemoveReport (state,payload) {
            state.ReportId = ''
            const {user} = payload
            let ReportTimeData = state.ReportTimeData
            ReportTimeData.map(element => {
                element.map (item => {
                    if (item.report.uname == user) {
                        item.report = {}
                    }
                    return item
                })
                return element
            });
        },
        chooseStatus (state,payload) {

            const {index,index2} = payload
            let ReportTimeData = state.ReportTimeData
            ReportTimeData = ReportTimeData.map ( (ele,i) => {
                const eleList2 = ele.map( (ele2,i2) => {
                    if (i == index && i2 == index2) {
                        // console.log( Object.keys(ele2.report).length,'report');
                        ele2.report = []
                    }
                    return ele2
                })
                return eleList2
            })
            state.ReportTimeData = ReportTimeData
        },
        // 填写超时原因修改
        addOverTimeInfo (state,payload) {
            const {id,mark_out} = payload
            console.log(payload,'payload');
            let obj = state.ReportListData.find (i => {
                return i.id == id
            })
            obj.mark_out = mark_out
        },
    },
    actions: {
        // 获取支持人员的数据
        async getSupportData ({state,commit},payload) {
            await oApi.getSupport(payload).then (res => {
                const list = res.data.result.list
                commit('SaveSupportData',list)
            })
        },
        // 获取支持人员的数据2
        async getSupportData3 ({state,commit},payload) {
            await oApi.getSupport(payload).then (res => {
                const list = res.data.result.list
                commit('SaveSupportData2',list)
            })
        },
        // 获取渠道列表
        async getSource ({state,commit},payload) {
            await oApi.getSource(payload).then (res => {
                const list = res.data.result
                console.log(list,'list')
                commit('SaveSourceList',list)
            })
        },
        async getSupportData2 ({state,commit},payload) {
            await oApi.getSupport(payload).then (res => {
                let list = res.data.result.list
                list = list.filter( item => {
                    return item.systemuserid != state.CustomerData[0].new_salesperson_id
                })
                commit('SaveSupportData2',list)
            })
        },
        async getCustomerData({state,commit},payload) {
            await oApi.getCustomer(payload).then (res => {
                let list = res.data.result.list
                list = list.map( item => {
                    item.name_info = item.name + '(' + item.new_telephone.substring(7) + ')'
                    return item
                })
                commit('SaveCustomerData',list)
            })
        },
        // 默认带出潜客
        async getCustomerObj({state,commit},payload) {
            await oApi.getCustomer(payload).then (res => {
                const list = res.data.result.list
                commit('SaveCustomerObj',list)
            })
        },
        async SendReportShare({state,commit},payload) {
            await oApi.ReportShare(payload).then (res => {
            })
        },
        async ProjectUncheck({state,commit},payload) {
            await oApi.ProjectUncheck(payload).then (res => {
                console.log(res,'不点检提交结果');
            })
        },
        async writeOff({state,commit},payload) {
            await oApi.writeOff(payload).then (res => {
                console.log(res,'核销结果');
            })
        },
        async writeOff2({state,commit},payload) {
            await oApi.writeOff2(payload).then (res => {
                console.log(res,'未预约核销结果');
            })
        },
        // 获取用户预约信息
        async getSelectList({state,commit},payload) {
            await oApi.getSelectList(payload).then (res => {
                console.log(res,'预约信息列表');
                let list = res.data.result.list;

                // list = list.filter( (item,idx) => {
                //     let index = list.findIndex( ele => ele.uname == item.uname && ele.mark_date == item.mark_date)
                //     return index == idx
                // })
                list = list.map( item => {
                    // 是否预约连续
                    let boolean = item.sub.every( (ele,index) => {
                        if (index == item.sub.length - 1) {
                            return true
                        }
                        if (item.sub[index].mark_start == item.sub[index + 1].mark_end) {
                            return true
                        } else {
                            console.log(item.sub[index].mark_start,item.sub[index + 1].mark_end,'item[index + 1].mark_end')
                            return false
                        }
                    })
                    if (boolean) {
                        item.showInfo = Number(item.sub[item.sub.length - 1].mark_start.split(' ')[0].split('-')[0]) + '.' + Number(item.sub[item.sub.length - 1].mark_start.split(' ')[0].split('-')[1])+'.' + Number(item.sub[item.sub.length - 1].mark_start.split(' ')[0].split('-')[2]) + ' ' + item.sub[item.sub.length - 1].mark_start.split(' ')[1].substring(0,5) + '~' + item.sub[0].mark_end.split(' ')[1].substring(0,5) + item.uname
                    } else {
                        item.showInfo = Number(item.mark_start.split(' ')[0].split('-')[0]) + '.' + Number(item.mark_start.split(' ')[0].split('-')[1]) + '.' + Number(item.mark_start.split(' ')[0].split('-')[2]) + " " + item.mark_start.split(' ')[1].substring(0,5)+'~' + item.mark_end.split(' ')[1].substring(0,5) + item.uname
                    }
                    return item
                    console.log(boolean,'boolean')
                })
                // list = list.map(item => {
                //     item.showInfo = Number(item.mark_start.split(' ')[0].split('-')[0]) + '.' + Number(item.mark_start.split(' ')[0].split('-')[1]) + '.' + Number(item.mark_start.split(' ')[0].split('-')[2]) + "." + item.mark_start.split(' ')[1].substring(0,5)+'~' + item.mark_end.split(' ')[1].substring(0,5) + item.uname
                //     return item
                // })
                let SelectList = [...state.SelectList,...list];
                commit('SaveSelectList',SelectList)
            })
        },

        // 获取核销列表
        async writeOffList({state,commit},payload) {
            await oApi.writeOffList(payload).then (res => {
                let list = res.data.result.list;
                // list.map(item => {
                //     item.time = item.created_at.split(' ')[0].split('-').join('.')
                //     return item
                // })
                // console.log(list,'list')
                // 过滤时间，将不是今天和昨天的数据全部都清楚
                // let date = Date.parse(new Date())
                // date = new Date(date - 1000*24*60*60 )
                // const year = date.getFullYear()
                // let month = date.getMonth() + 1
                // let day = date.getDate()
                // month = month < 10 ? '0' + month : month
                // day = day < 10 ? '0' + day : day
                // let timed = `${year}.${month}.${day}`
                // console.log(timed,'timed')
                // list = list.filter (item => item.time > timed)
                // console.log(list,'list')
                let writeOffList = [...state.writeOffList,...list]
                console.log(writeOffList,'writeOffList')
                writeOffList = writeOffList.map( item => {
                    item.time_info = item.created_at.split(' ')[1]
                    return item
                })
                commit('SavewriteOffList',writeOffList.reverse());
            })
        },
        async getTemplateRoomData({state,commit},payload) {
            await oApi.getTemplateRoom(payload).then (res => {
                let list = res.data.result.list
                list = list.map (item => {
                    // 判断new_community是否存在，存在就使用他，不存在就使用new_address替代
                    if (!item.new_community) {
                        item.templateName = item.new_address
                    } else {
                        item.templateName = item.new_community
                    }
                    return item
                })
                commit('SaveTemplateRoomData',list)
            })
        },
        async getReportTimeData({state,commit},payload) {
            await oApi.getReportTime(payload).then (res => {
                const list = res.data.result.list
                let timeList = []
                let threelist = []
                for (let index = 0; index < list.length; index++) {
                    threelist.push(list[index])
                    if((index + 1) % 3 == 0) {
                        timeList.push(threelist)
                        timeList.push(threelist)
                        threelist = []
                    }
                }
                if (threelist.length != 0) {
                    timeList.push(threelist)
                    timeList.push(threelist)
                }
                commit('SaveReportTimeData',timeList)
            })
        },
        // 获取今天和昨天的时间数据
        async getReportTimeData2({state,commit},payload) {
            let timeList = []

            // 昨天数据
            let nowdate = Date.parse(new Date())
            //时间搓转化成正常时间
            let date2 = new Date(nowdate - 1000*24*60*60 );
            const year = date2.getFullYear()
            let month2 = date2.getMonth() + 1
            let day2 = date2.getDate()
            month2 = month2 < 10 ? '0' + month2 : month2
            day2 = day2 < 10 ? '0' + day2 : day2
            payload.date = `${year}-${month2}-${day2}`
            await oApi.getReportTime(payload).then (res => {
                let list = res.data.result.list
                list = list.filter( item => {
                    return !item.report.id
                })
                let timeObj = {
                    timeTitle:`${date2.getMonth() + 1}月${date2.getDate()}日`,
                    list
                }
                timeList.push(timeObj)
            })
            // 今天数据
            let date = new Date()
            let month = date.getMonth() +1
            let day = date.getDate()
            month = month < 10 ? '0' + month : month
            day = day < 10 ? '0' + day : day
            console.log(payload,'payload')
            payload.date = `${year}-${month}-${day}`
            await oApi.getReportTime(payload).then (res => {
                let list = res.data.result.list
                list = list.filter( item => {
                    return !item.report.id
                })
                let timeObj = {
                    timeTitle:`${date.getMonth() +1}月${date.getDate()}日`,
                    list
                }
                timeList.push(timeObj)
            })
            timeList = timeList.reverse()
            commit('SaveReportTimeData2',timeList)
        },
        // 样板间预约
        async getReportAppointData({state,commit},payload) {
            // conoApi.st ReportTimeData = state.ReportTimeData
            await oApi.getAppoint(payload).then (res => {
                const list = res.data.result.list
                // commit('SaveReportAppointData',list)
            })
        },
        // 获取体验间详情
        async getTemplateDetail({state,commit},payload) {
            await oApi.getTemplateDetail(payload).then (res => {
                console.log(res,'体验间详情')
                commit('SaveTemplateDetail',res.data.result)
            })
        },
        // 获取报告信息
        async getReportId({state,commit},payload) {
            await oApi.getReportinfo(payload).then (res => {
                const result = res.data.result
                commit('SaveReportId',result.infos.id)
            })
        },
        // b端报告详情
        async getReportInfoData({state,commit},payload) {
            await oApi.getReportinfo(payload).then (res => {
                const result = res.data.result
                commit('SaveReportUserInfoData',result.infos)
                commit('SaveReportTagsData',result.tags)
            })
        },
        // b端报告详情
        async UploadImg({state,commit},payload) {
            await oApi.UploadImg(payload).then (res => {
                commit('SaveUploadImg',res.data.result.local_url)
            })
        },
        async getCReportInfoData({state,commit},payload) {
            await oApi.getCreportInfoData(payload).then (res => {
                console.log(res,'报告详情');
                const result = res.data.result
                commit('SaveReportUserInfoData',result.infos)
                commit('SaveReportTagsData',result.tags)
            })
        },
        async getReportRestData({state,commit},payload) {
            await oApi.getReportRest(payload).then (res => {
                // console.log(res,'休息日');
                const list = res.data.result.list
                commit('SaveReportRestData',list)
            })
        },
        async getReportConfigData({state,commit},payload) {
            await oApi.getReportConfig(payload).then (res => {
                // console.log(res,'报告需求');
                const list = res.data.result.list
            })
        },
        // 获取负责的列表
        async ProjectGroup({state,commit},payload) {
            await oApi.ProjectGroup(payload).then (res => {
                const list = res.data.result
                commit('SaveBchargePeople',list.length)
            })
        },
        // 报名列表
        async getReportListData({state,commit},payload) {
            await oApi.getReportlist(payload).then (res => {
                const result = res.data.result
                commit('SaveReportListData',result.list)
                // console.log(result.location_skip,'result.location_skip')
                commit('SaveLocationSkip',result.location_skip)
                // commit('SaveReportCount',{count:result.num_account,list:result.count})
            })
        },
        // 新增报告列表（下拉触底刷新）
        async getReportListDatas({state,commit},payload) {
            await oApi.getReportlist(payload).then (res => {
                const result = res.data.result
                commit('SaveReportListDatas',result.list)
            })
        },
        // 获取体验间点检列表
        async getCheckList({state,commit},payload) {
            await oApi.getCheckList(payload).then (res => {
                const result = res.data.result
                // console.log(result.list,'result.list');
                let list = result.list.map( item => {
                    // 如果是未点检，需要判断是多少天未点检
                    if (item.state == 0) {
                        item.myState = 0
                        item.myTips = '点检'
                    } else if (item.state == 1) {
                        let createdTime = item.created_date.replace(/-/g, '/');
                        createdTime = new Date(createdTime).getTime()
                        let nowTime = Date.parse(new Date())
                        // 如果没过7天。
                        // 如果过了7天。没过14天
                        // 如果过了14天
                        if (nowTime < (createdTime + 7 * 24 *60 *60 *1000)) {
                            item.myState = 0
                            item.myTips = '点检'
                        } else if (nowTime > (createdTime + 7 * 24 *60 *60 *1000) && nowTime < (createdTime + 14*24*60*60*1000)) {
                            item.myState = 1
                            item.myTips = '未点检反馈'
                        } else if (nowTime > (createdTime + 14*24*60*60*1000)) {
                            item.myState = 5
                            item.myTips = '无故未点检'
                        }
                    } else if (item.state == 2) {
                        item.myState = 2
                        item.myTips = '问题事项'
                    } else if (item.state == 3) {
                        item.myState = 3
                        item.myTips = '点检合格'
                    } else if (item.state == 4) {
                        item.myState = 4
                        item.myTips = '未点检原因'
                    }
                    return item
                })
                console.log(list,'list')
                commit('SaveCheckList',list)
            })
        },
        // 获取距离
        async getDistance2({state,commit},payload) {
            await oApi.getDistance2(payload).then (res => {
                const data = res.data.result
                commit('SaveDistance',data.distance)
            })
        },
        // 现场打卡
        async getDiscussSign({state,commit},payload) {
            await oApi.getDiscussSign(payload).then (res => {
                const result = res.data.result
                console.log(result,'result')
            })
        },
        // 获取体验间点检列表(下拉添加数据)
        async getCheckList2({state,commit},payload) {
            await oApi.getCheckList(payload).then (res => {
                const result = res.data.result
                let list = result.list.map( item => {
                    // 如果是未点检，需要判断是多少天未点检
                    if (item.state == 0) {
                        item.myState = 0
                        item.myTips = '点检'
                    } else if (item.state == 1) {
                        let createdTime = item.created_date.replace(/-/g, '/');
                        createdTime = new Date(createdTime).getTime()
                        let nowTime = Date.parse(new Date())
                        // 如果没过7天。
                        // 如果过了7天。没过14天
                        // 如果过了14天
                        if (nowTime < (createdTime + 7 * 24 *60 *60 *1000)) {
                            item.myState = 0
                            item.myTips = '点检'
                        } else if (nowTime > (createdTime + 7 * 24 *60 *60 *1000) && nowTime < (createdTime + 14*24*60*60*1000)) {
                            item.myState = 1
                            item.myTips = '未点检反馈'
                        } else if (nowTime > (createdTime + 14*24*60*60*1000)) {
                            item.myState = 5
                            item.myTips = '无故未点检'
                        }
                    } else if (item.state == 2) {
                        item.myState = 2
                        item.myTips = '问题事项'
                    } else if (item.state == 3) {
                        item.myState = 3
                        item.myTips = '点检合格'
                    } else if (item.state == 4) {
                        item.myState = 4
                        item.myTips = '未点检原因'
                    }
                    return item
                })
                commit('SaveCheckList2',list)
            })
        },
        // 获取体验间点检列表() cktime使用
        async getCheckList3({state,commit},payload) {
            await oApi.getCheckList(payload).then (res => {
                const result = res.data.result
                commit('SaveCheckList3',result.list)
            })
        },
        // 获取体验间点检列表() cktime使用
        async getCheckList4({state,commit},payload) {
            await oApi.getCheckList(payload).then (res => {
                const result = res.data.result
                commit('SaveCheckList4',result.list)
            })
        },
        // 体验间点检搜素
        async getProjectpre({state,commit},payload) {
            await oApi.getProjectpre(payload).then (res => {
                const result = res.data.result
                commit('SaveSelectColumn',result)
            })
        },
        // 获取身份信息
        async getIdentity({state,commit},payload) {
            await oApi.getIdentity(payload).then (res => {
                const result = res.data.result
                commit('SaveIdentity',result.is_wind_discuss == 1)
            })
        },
        // 预约回顾
        async getReportList({state,commit},payload) {
            // conoApi.sole.log(payload);
            await oApi.getReportlist(payload).then (res => {
                console.log(res,'huigu');
                const result = res.data.result
                commit('SaveReportList',result.list)
                // commit('SaveReportCount',result.count)
            })
        },
        // 取消预约
        async SendReportCancel({state,commit},payload) {
            await oApi.ReportCancel(payload).then (res => {
                // console.log(res,'取消预约');
            })
        },
        async SendReportCancel2({state,commit},payload) {
            await oApi.cancelAppoint2(payload).then (res => {
                // console.log(res,'取消预约');
            })
        },
        // 接受邀请（潜客）
        async SendDiscussAccept({state,commit},payload) {
            await oApi.DiscussAccept(payload).then (res => {
            })
        },
        // 接受邀请（非潜客）
        async SendDiscussAccept2({state,commit},payload) {
            await oApi.DiscussAccept2(payload).then (res => {
            })
        },
        // 点检信息查看
        async ProjectCheckInfo({state,commit},payload) {
            await oApi.ProjectCheckInfo(payload).then (res => {
                console.log(res,'点检信息');
                commit('SaveCheckInfoList',res.data.result.items)
            })
        },
        // 体验间点检提交
        async ProjectCheck({state,commit},payload) {
            await oApi.ProjectCheck(payload).then (res => {
                console.log(res,'提交点检');
            })
        },
        async SendSignIn({state,commit},payload) {
            await oApi.SignIn(payload).then (res => {
            })
        },
        async SendCheckSignIn({state,commit},payload) {
            await oApi.CheckSignIn(payload).then (res => {
                const data = res.data.result
                commit('SaveDistance',data.distance)
            })
        },
        async getAgreementData({state,commit},payload) {
            await oApi.getAgreement(payload).then (res => {
                const data = res.data.result
                commit('SaveAgreement',data.content)
                console.log(data);
            })
        },
        async SendcancelAppoint({state,commit},payload) {
            await oApi.cancelAppoint(payload).then (res => {
                console.log(res,'取消');
            })
        },
        async SendReportappoints({state,commit},payload) {
            await oApi.getAppoint(payload).then (res => {
                console.log(res,'同时预约多个时间段');
            })
        },
        async SendreportoutInfo({state,commit},payload) {
            await oApi.Sendreportout(payload).then (res => {
            })
        },
        async getReportfeed({state,commit},payload) {
            await oApi.getReportfeed(payload).then (res => {
                let feed_type = res.data.result.feed_type
                let feed = res.data.result.feed
                commit('SaveFeedType',feed_type)
                commit('SaveFeedObj',feed)
            })
        },

        async SendreportFeed({state,commit},payload) {
            await oApi.SendreportFeed(payload).then (res => {
            })
        },
        // 获取装修公司列表
        async getPosterList({state,commit},payload) {
            await oApi.getPosterList(payload).then (res => {
                console.log(res.data.result,'设计师列表');
                commit('SaveCompanyList',res.data.result)
            })
        },
        // 获取周期预约状态
        async getProjectTime({state,commit},payload) {
            await oApi.getProjectTime(payload).then (res => {
                commit('SaveProjectTime',res.data.result)
            })
        },
    },
    getters: {},
    modules:{
        commonVuex
    }
}

